import {
    GETWAYLISTADMIN_SUCCESS,
    GETWAYLISTADMIN_FAILED,
    RESET_GETWAYLISTADMIN,
    LOADING_GETWAYLISTADMIN,
    NETWORK_ERROR_GETWAYLISTADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWAYLISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETWAYLISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETWAYLISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETWAYLISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETWAYLISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
